import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'configs/msalConfig';
import { env } from 'configs/EnvironmentConfig';

let initPromise = null;

/**
 * Create and bootstrap the single shared MSAL instance.
 * Per MSAL guidance, initialize() must run before any other API, and
 * handleRedirectPromise() completes any in-flight redirect and clears a stray
 * auth fragment from the main window (a no-op for the popup flow).
 */
const initializeMsal = () => {
	if (!initPromise) {
		const instance = new PublicClientApplication(msalConfig);
		initPromise = instance
			.initialize()
			.then(() => instance.handleRedirectPromise())
			.then(() => instance)
			.catch((error) => {
				// Reset so a later attempt can retry a clean bootstrap.
				initPromise = null;
				throw error;
			});
	}

	return initPromise;
};

export const acquireMsalInstance = () => {
	if (!env.MICROSOFT_CLIENT_ID) {
		return Promise.resolve(null);
	}

	return initializeMsal();
};

/** Bootstrap MSAL at app startup (no-op when Microsoft auth is not configured). */
export const bootstrapMsal = () => {
	if (!env.MICROSOFT_CLIENT_ID) {
		return Promise.resolve(null);
	}

	return initializeMsal().catch(() => null);
};
